// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/product-offering-slider/product-offering-slider.component.scss
// module id = 453
// module chunks = 0